(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldPromoCode', ['PromoCodeModel', 'thfFieldHelper', '$sce', function (PromoCodeModel, thfFieldHelper, $sce) {
        var link = function (scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');

            scope.loading = false;
            scope.valid = {
                show: false,
                icon: scope.formState.icon.tick
            };
            scope.originalValidationRules = scope.validationRules[scope.field.name];
            scope.validation[scope.field.name] = {result: true, message: ''};

            scope.$watch('model.'+scope.field.name, function(newValue, oldValue) {
                if(oldValue !== newValue) {
                    scope.model[scope.field.name] = thfFieldHelper.escapeValue(scope.model[scope.field.name]);
                }
            }, true);
            
            function promoCodeCheck() {
                scope.valid.show = false;

                if( typeof scope.model[scope.field.name] !== 'undefined' && scope.model[scope.field.name] !== '' ) {
                    scope.loading = true;
                    PromoCodeModel.validatePromoCode(scope.model[scope.field.name]).then(
                        function (response) {
                            if( response.result ) {
                                scope.valid.icon = scope.formState.icon.tick;
                                scope.formState.validation[scope.field.name] = true;
                                scope.validation[scope.field.name].result = true;
                                scope.validation[scope.field.name].message = '';
                            }
                            else {
                                scope.valid.icon = scope.formState.icon.invalid;
                                scope.formState.validation[scope.field.name] = false;
                                scope.validation[scope.field.name].result = false;
                                scope.validation[scope.field.name].message = 'Must be a valid promo code';
                            }
                            scope.valid.show = true;
                            scope.loading = false;
                        },
                        function () {
                            scope.formState.validation[scope.field.name] = false;
                            scope.valid.show = true;
                            scope.valid.icon = scope.formState.icon.invalid;
                            scope.loading = false;
                            scope.validation[scope.field.name].result = false;
                            scope.validation[scope.field.name].message = 'Oops! Seems like you have the wrong promo code';
                        });
                }
                else if(typeof scope.model[scope.field.name] !== 'undefined' && scope.model[scope.field.name] === '') {
                    scope.formState.validation[scope.field.name] = true;
                    scope.validation[scope.field.name].result = true;
                    scope.validation[scope.field.name].message = '';
                }
            }

            scope.$watch('model.'+scope.field.name, promoCodeCheck, true);
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/bsb.html');
            }
        };
    }]);
})(jQuery, angular, window);
